// 主人公の歩き 6 版目 (2026-10-13・DEV ?lunaWalk=v6a|v6b|v6c) の脚と腰。 配布版は変えない。
//   5 版目 (?lunaWalk=v5) の答え: 膝のカクつき＝消えた・重み＝「重すぎる・もっさり」・配布版へ＝まだ、
//   原文「歩く時の姿勢？ずっと気になってるのは足だけで歩いてる感じがあること。」
//   記録 = docs/research/2026-10-13-lunaire-walk-v6.md
//
//   測った「足だけ」の正体: 5 版目の上半身は腰の上下にそのまま乗っているだけで、腰に対して動くのは 1px 前後
//   (胸の上下 1.1px・肩の前後 0.4〜0.7px・胴の傾きの揺れ 1.0°)。 見本 Z1 (ZZZ ベル) は肩が前後に 4.5px、手が 21px 振れ、
//   頭はほとんど前後しない (0.7px)。 しかも 5 版目の空いた手は、同じ側の足と一緒に前へ出ていた (人の歩きは逆)。
//
//   v6a / v6b の脚と腰 = 5 版目そのもの (V5_WALK・膝の 1 コマの変化 7.1°)。 上半身だけ scripts/author_player_walk_v6.ts で変える。
//   v6c の脚と腰 = 重心の乗り移りを主にした版: 1 歩を 0.45 → 0.43 秒にして腰の上下を軽く速く (幅 2.9 → 約 2.1px・平均 0.5px 高く)、
//   体が床の足の上を越える間にわずかに遅れ、両足が着く所で前へ出る (腰の前後の揺れ hipSurge・見本 Z3 の頭と腰の前後から)。
//
//   このファイルは描画にもゲームの判定にも使う = Spine を import しない (テストから読める)。
import { V5_WALK, type V5Gait } from './player_walk_v5'

/** v6a / v6b: 脚と腰は 5 版目と同じ (膝の作り方・速さ 110・1 歩 0.45 秒) */
export const V6_WALK: V5Gait = V5_WALK

/**
 * v6c: 腰の上下を軽く速く＋重心の乗り移り。
 *   1 歩 0.43 秒 (5 版目 0.45)。 速さ 110 のまま歩幅が 49.5 → 47.3px になり、両足が着く所の腰の沈みが浅くなる (腰の上下の幅 2.9 → 約 2.1px)。
 *   着地の位置 20.2px・腰を均す幅 0.08 は、膝の 1 コマの変化が 5 版目と同じくらい (7.3°) に収まる所を振って選んだ。
 *   腰の前後 (hipSurge): 見本 Z3 の頭と腰 (刀の柄) の前後を 1 歩に折りたたむと、体が一番低い所 (両足が着いた所) の少し後に一番前、
 *   片足で立っている間の後半に一番後ろ (人は床の足の上を越える間に遅くなり、両足が着く所で速くなる)。 着地を 0 にして写すと
 *   一番前が 1 歩の 0.33・一番後ろが 0.88。 幅は Z3 の柄の約 2.6px の半分弱、±0.6px にした (柄は腰のひねりでも動くため 🔶)。
 */
export const V6C_WALK: V5Gait = {
  ...V5_WALK,
  stepSec: 0.43,
  contactFwdPx: 20.2,
  hipWindow: 0.08,
  hipSurge: [{ t: 0.33, v: 0.6 }, { t: 0.88, v: -0.6 }],
}
